"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AWSImage_1 = __importDefault(require("components/design-system/AWSImage"));
const Avatar_1 = __importDefault(require("components/design-system/Avatar"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const TruncateParagraph_1 = __importDefault(require("components/shared/TruncateParagraph"));
const ProfileType = ({ isTeam, user, team, title, subtitle = '', customClass, statusComponent, titleClassName = '', subtitleClassName = '', onClick, size, truncateSubtitle = true, srcPicture, tooltipClassContainer = '' }) => {
    const [showTitleTooltip, setShowTitleTooltip] = (0, react_1.useState)(false);
    const titleRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if ((((_a = titleRef === null || titleRef === void 0 ? void 0 : titleRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) || 0) >
            (((_b = titleRef === null || titleRef === void 0 ? void 0 : titleRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0)) {
            setShowTitleTooltip(true);
        }
    }, []);
    return (react_1.default.createElement("div", { className: `flex w-full ${customClass ? customClass : ''}` },
        react_1.default.createElement(Avatar_1.default, { src: srcPicture ? srcPicture : user === null || user === void 0 ? void 0 : user.profilePicture, name: user === null || user === void 0 ? void 0 : user.name, statusComponent: statusComponent, onClick: onClick, size: size }),
        react_1.default.createElement("div", { className: `flex ${!subtitle ? 'items-center' : 'flex-col'} ml-[16px] overflow-hidden` },
            react_1.default.createElement(TooltipContainer_1.default, { show: showTitleTooltip, position: "bottom", text: title, key: 0, useMaxWidth: false, classContainer: `${tooltipClassContainer}` },
                react_1.default.createElement("p", { ref: titleRef, "data-cy": "title", className: `typography-h500 overflow-hidden truncate ${titleClassName}` }, title)),
            isTeam ? (react_1.default.createElement("div", { className: "flex" },
                (team === null || team === void 0 ? void 0 : team.teamPicture) && (react_1.default.createElement(AWSImage_1.default, { className: "team-picture rounded-[4px] w-[16px] h-[16px] mr-[4px]", src: team.teamPicture })),
                react_1.default.createElement("p", { className: "typography-h100 typography-secondary" }, `${team === null || team === void 0 ? void 0 : team.name} · ${user.role}`))) : truncateSubtitle ? (react_1.default.createElement(TruncateParagraph_1.default, { className: `${subtitleClassName
                    ? subtitleClassName
                    : 'typography-paragraph typography-secondary'}`, dataCy: "sub-title" }, subtitle)) : (subtitle && (react_1.default.createElement("p", { className: `${subtitleClassName
                    ? subtitleClassName
                    : 'typography-paragraph typography-secondary'} max-w-full` }, subtitle))))));
};
exports.default = ProfileType;
